import "./index.css";
import React from "react";
import { getYoutubeId } from "../../Utils/utils";

export default function VideoPlayer({
  src,
  className,
  isUploadedVideo,
  controls = true,
}) {
  if (!src) {
    return (
      <div className={`video-player__placeholder ${className}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 32 32"
          className="video-player__icon"
        >
          <path
            fill="currentColor"
            d="M20.31 6H4a2 2 0 0 0-2 2v16a3 3 0 0 0 0 .29zm9.15 2.11a1 1 0 0 0-1 .08L23 12.06v-1.62l7-7L28.56 2L2 28.56L3.44 30l4-4H21a2 2 0 0 0 2-2v-4.06l5.42 3.87A1 1 0 0 0 30 23V9a1 1 0 0 0-.54-.89"
          />
        </svg>
        <p className="video-player__text">No video available</p>
      </div>
    );
  }

  return isUploadedVideo ? (
    <video controls={controls} className={className}>
      <source src={src} type="video/mp4" />
      <source src={src} type="video/ogg" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <iframe
      title="video"
      width="100%"
      height="100%"
      src={`//www.youtube.com/embed/${getYoutubeId(
        src
      )}?modestbranding=1&showinfo=0`}
      allowFullScreen
      className={className}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js